module.exports = __webpack_public_path__ + "static/media/event_slide_4.6569a698.png";